/* eslint-disable quote-props */
import { toRem, toRems } from 'helpers/theme'

const style = ({ theme, imageHeight, mobileImage }) => ({
    // height: imageHeight,
    maxHeight: 640,
    // minHeight: mobileImage ? 0 : 470,
    borderRadius: 4,
    overflow: 'hidden',
    position: 'relative',
    textAlign: 'center',

    '& .viewGallery': {
        position: 'absolute',
        bottom: 20,
        right: 20,
        background: 'rgba(255, 255, 255, 0.8)',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.35)',
        borderRadius: 4,
        textTransform: 'uppercase',
        color: theme.colors.blueMid,
        fontWeight: 500,
        fontSize: toRem(11),
        padding: toRems([3, 10]),

        [theme.breakpoints.up('lg')]: {
            fontSize: toRem(14),
            padding: toRems([8, 15])
        }
    }
})

export default style
